<template>
  <div class="serviceProduct">
    <div class="request-bar">
      <div class="request-item has-chose">
        <div>所选分类</div>
        <div>
          <span v-for="(ele, index) in hasBeChosed" :key="index">
            {{
            ele.dict_item_name
            ? ele.dict_item_name
            : ele.classify_name
            ? ele.classify_name
            : ele.alternation_name
            }}
            <i
              class="iconfont icon-android-cancel"
              @click="cancelChosed(ele)"
            ></i>
          </span>
        </div>
      </div>
      <div class="request-item">
        <div>产品分类</div>
        <div>
          <div class="check-item-all">
            <input type="checkbox" :checked="isCheckedAll" class="hide-item" id="pro-input-all" />
            <label for="pro-input-all" @click="checkedAll(1)">
              <img
                :src="isCheckedAll ? checkedImgs : unCheckedImgs"
                width="14"
                height="14"
                class="label-style"
              />全部
            </label>
          </div>
          <div v-for="item in productList" :key="item.classify_id" class="check-item-one">
            <input
              type="checkbox"
              :checked="checkAllGroup.indexOf(item) >= 0"
              name="checkboxinput"
              class="hide-item"
              id="file-input"
            />
            <label
              for="file-input"
              @click="item.checked=!item.checked;checkedOne(1, item);handleGioTrack(1,item.checked, item.lastName|| item.classify_name,item.lastName && item.classify_name)"
            >
              <img
                :src="
                  checkAllGroup.indexOf(item) >= 0 ? checkedImgs : unCheckedImgs
                "
                width="14"
                height="14"
                class="label-style"
              />
              {{ item.classify_name }}
            </label>
            <div
              v-if="item.child_classify && item.child_classify.length > 0"
              class="secondary-menu-box"
            >
              <img
                :src="require('@/assets/service/icon_arr_down.png')"
                alt
                class="secondary-menu-img"
              />
              <div class="secondary-menu-list">
                <div
                  v-for="it in item.child_classify"
                  :key="it.child_classify_id"
                  class="secondary-menu-item"
                  @click.stop.prevent="item.checked=true;choseOne(it, item.classify_id);handleChoseChild(item.lastName, it.child_classify_name)"
                >{{ it.child_classify_name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="request-item">
        <div>通用行业</div>
        <div>
          <div class="check-item-all">
            <input
              type="checkbox"
              :checked="isCheckedAllGen"
              class="hide-item"
              id="gener-input-all"
            />
            <label for="gener-input-all" @click="checkedAll(2)">
              <img
                :src="isCheckedAllGen ? checkedImgs : unCheckedImgs"
                width="14"
                height="14"
                class="label-style"
              />全部
            </label>
          </div>
          <div v-for="item in generalList" :key="item.dict_item_code" class="check-item-one">
            <input
              type="checkbox"
              :checked="checkAllGeneral.indexOf(item) >= 0"
              name="checkboxinput"
              class="hide-item"
              id="general-input"
            />
            <label
              for="general-input"
              @click="item.checked=!item.checked;checkedOne(2, item);handleGioTrack(2,item.checked, item.dict_item_name)"
            >
              <img
                :src="
                  checkAllGeneral.indexOf(item) >= 0
                    ? checkedImgs
                    : unCheckedImgs
                "
                width="14"
                height="14"
                class="label-style"
              />
              {{ item.dict_item_name }}
            </label>
          </div>
        </div>
      </div>
      <div class="request-item">
        <div>交付方式</div>
        <div>
          <div class="check-item-all">
            <input type="checkbox" :checked="isCheckedAllPay" class="hide-item" id="pay-input-all" />
            <label for="pay-input-all" @click="checkedAll(3)">
              <img
                :src="isCheckedAllPay ? checkedImgs : unCheckedImgs"
                width="14"
                height="14"
                class="label-style"
              />全部
            </label>
          </div>
          <div v-for="item in payList" :key="item.id" class="check-item-one">
            <input
              type="checkbox"
              :checked="checkAllPay.indexOf(item) >= 0"
              name="checkboxinput"
              class="hide-item"
              id="pay-input"
            />
            <label
              for="pay-input"
              @click="item.checked=!item.checked;checkedOne(3, item);handleGioTrack(3,item.checked, item.alternation_name)"
            >
              <img
                :src="
                  checkAllPay.indexOf(item) >= 0 ? checkedImgs : unCheckedImgs
                "
                width="14"
                height="14"
                class="label-style"
              />
              {{ item.alternation_name }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import checkedImg from '@/assets/service/checkbox_checked.png'
import unCheckedImg from '@/assets/service/checkbox_unchecked.png'
import { getSearchConditionsInit } from '@/api/market.js'
export default {
  name: 'serviceProduct',
  data () {
    return {
      checkedImgs: checkedImg,
      unCheckedImgs: unCheckedImg,
      checkAll: false,
      checkAllGroup: [],
      checkGeneral: false,
      checkAllGeneral: [],
      checkPay: false,
      checkAllPay: [],
      productList: [], //产品分类
      generalList: [], //通用行业
      payList: [], //支付方式
      hasBeChosed: [], //所选分类
      Quotation: 0, //行情字段
      checkQuotation: false, //行情下拉框
      value: '', //标记type的值
      isCheckedAll: false, //产业全选
      isCheckedAllGen: false, //通用全选
      isCheckedAllPay: false //交付方式全选
    }
  },

  computed: {},
  mounted () {
    this.getSearchInfo()
  },

  methods: {
    // 全选
    checkedAll (num) {
      let key = 'type'
      let value = 0
      let isHasEle = 0
      if (num == 1) {
        value = 1
        this.isCheckedAll = !this.isCheckedAll
        if (this.isCheckedAll) {
          // 全选时
          this.checkAllGroup = []
          this.productList.forEach(function (ele) {
            this.checkAllGroup.push(ele)
            if (this.hasBeChosed.indexOf(ele) < 0) {
              ele[key] = value
              this.hasBeChosed.push(ele)
            }
          }, this)
        } else {
          this.checkAllGroup = []
          this.productList.forEach(ele => {
            isHasEle = this.hasBeChosed.indexOf(ele)
            if (isHasEle >= 0) {
              this.hasBeChosed.splice(isHasEle, 1)
            }
          })
        }
      } else if (num == 2) {
        value = 2
        this.isCheckedAllGen = !this.isCheckedAllGen
        if (this.isCheckedAllGen) {
          // 全选时
          this.checkAllGeneral = []
          this.generalList.forEach(function (ele) {
            this.checkAllGeneral.push(ele)
            if (this.hasBeChosed.indexOf(ele) < 0) {
              ele[key] = value
              this.hasBeChosed.push(ele)
            }
          }, this)
        } else {
          this.checkAllGeneral = []
          this.generalList.forEach(ele => {
            isHasEle = this.hasBeChosed.indexOf(ele)
            if (isHasEle >= 0) {
              this.hasBeChosed.splice(isHasEle, 1)
            }
          })
        }
      } else if (num == 3) {
        value = 3
        this.isCheckedAllPay = !this.isCheckedAllPay
        if (this.isCheckedAllPay) {
          // 全选时
          this.checkAllPay = []
          this.payList.forEach(function (ele) {
            this.checkAllPay.push(ele)
            if (this.hasBeChosed.indexOf(ele) < 0) {
              ele[key] = value
              this.hasBeChosed.push(ele)
            }
          }, this)
        } else {
          this.checkAllPay = []
          this.payList.forEach(ele => {
            isHasEle = this.hasBeChosed.indexOf(ele)
            if (isHasEle >= 0) {
              this.hasBeChosed.splice(isHasEle, 1)
            }
          })
        }
      }
      this.$store.commit('SET_REQUEST', this.hasBeChosed)
    },

    // 子级分类埋点
    handleChoseChild (name1, name2) {
      this.gioTrackEvent('OP_productCategoryClick', {
        dimName_var: '产品分类',
        firstCategoryName_var: name1 || '-',
        secondCategoryName_var: name2 || '-'
      })
    },
    // 埋点
    handleGioTrack (a, checked, name1 = '', name2 = '') {
      // 勾选了才取统计
      if (checked == true) {
        // 筛选维度
        let dimName = a === 1 ? '产品分类' : a === 2 ? '适用行业' : a === 3 ? '交付方式' : '-'
        this.gioTrackEvent('OP_productCategoryClick', {
          dimName_var: dimName,
          firstCategoryName_var: name1 || '-',
          secondCategoryName_var: name2 || '-'
        })
      }
    },
    // 选择
    checkedOne (a, num) {
      let inChoseIndex = this.hasBeChosed.indexOf(num)
      let key = 'type'
      if (a == 1) {
        let idIndex = this.checkAllGroup.indexOf(num)
        if (idIndex >= 0) {
          this.checkAllGroup.splice(idIndex, 1)
          this.hasBeChosed.splice(inChoseIndex, 1)
        } else {
          let value = 1
          num[key] = value
          this.checkAllGroup.push(num)
          this.hasBeChosed.push(num)
        }
        if (this.checkAllGroup.length === this.productList.length) {
          this.isCheckedAll = true
        } else {
          this.isCheckedAll = false
        }
      } else if (a == 2) {
        let idIndex = this.checkAllGeneral.indexOf(num)
        if (idIndex >= 0) {
          this.checkAllGeneral.splice(idIndex, 1)
          this.hasBeChosed.splice(inChoseIndex, 1)
        } else {
          let value = 2
          num[key] = value
          this.checkAllGeneral.push(num)
          this.hasBeChosed.push(num)
        }
        if (this.checkAllGeneral.length === this.generalList.length) {
          this.isCheckedAllGen = true
        } else {
          this.isCheckedAllGen = false
        }
      } else if (a == 3) {
        let idIndex = this.checkAllPay.indexOf(num)
        if (idIndex >= 0) {
          this.checkAllPay.splice(idIndex, 1)
          this.hasBeChosed.splice(inChoseIndex, 1)
        } else {
          let value = 3
          num[key] = value
          this.checkAllPay.push(num)
          this.hasBeChosed.push(num)
        }
        if (this.checkAllPay.length === this.payList.length) {
          this.isCheckedAllPay = true
        } else {
          this.isCheckedAllPay = false
        }
      }
      this.$store.commit('SET_REQUEST', this.hasBeChosed)
    },
    //所选分类-取消选中
    cancelChosed (ele) {
      let inChoseIndex = this.hasBeChosed.indexOf(ele)
      let idIndex = 0
      let isHasEle = 0
      if (ele.type == 1) {
        idIndex = this.checkAllGroup.indexOf(ele)
        idIndex >= 0 ? this.checkAllGroup.splice(idIndex, 1) : ''
        if (this.checkAllGroup.length === this.productList.length) {
          this.isCheckedAll = true
        } else {
          this.isCheckedAll = false
        }
      } else if (ele.type == 2) {
        idIndex = this.checkAllGeneral.indexOf(ele)
        idIndex >= 0 ? this.checkAllGeneral.splice(idIndex, 1) : ''
        if (this.checkAllGeneral.length === this.generalList.length) {
          this.isCheckedAllGen = true
        } else {
          this.isCheckedAllGen = false
        }
      } else if (ele.type == 3) {
        idIndex = this.checkAllPay.indexOf(ele)
        idIndex >= 0 ? this.checkAllPay.splice(idIndex, 1) : ''
        if (this.checkAllPay.length === this.payList.length) {
          this.isCheckedAllPay = true
        } else {
          this.isCheckedAllPay = false
        }
      }
      this.hasBeChosed.splice(inChoseIndex, 1)
      this.$store.commit('SET_REQUEST', this.hasBeChosed)
    },
    //二级选中
    choseOne (a, id) {
      let this_ = this
      for (let i = 0; i < this_.productList.length; i++) {
        if (this_.productList[i].classify_id == id) {
          if (this_.productList[i].classify_name == a.child_classify_name) {
            this_.productList[i].classify_name = this_.productList[i].lastName
            this_.productList[i].beSelectedChildId = ''
          } else {
            if (!this_.productList[i].beSelectedChildId) {
              this_.productList[i].lastName = this_.productList[i].classify_name
            }
            this_.productList[i].classify_name = a.child_classify_name
            this_.productList[i].beSelectedChildId = a.child_classify_id
            if (this_.checkAllGroup.length > 0) {
              let isHas = false
              this_.checkAllGroup.forEach(el => {
                if (el.classify_id == this_.productList[i].classify_id) {
                  isHas = true
                }
              })
              if (isHas) {
                for (var m = 0; m < this_.checkAllGroup.length; m++) {
                  if (
                    this_.checkAllGroup[m].classify_id ==
                    this_.productList[i].classify_id
                  ) {
                    this_.checkAllGroup[m].beSelectedChildId =
                      a.child_classify_id
                    this_.checkAllGroup[m].classify_name = a.child_classify_name
                  }
                }
              } else {
                let value = 1
                this_.productList[i].type = value
                this.checkAllGroup.push(this_.productList[i])
                this.hasBeChosed.push(this_.productList[i])
              }
            } else {
              this_.checkedOne(1, this_.productList[i])
            }
          }
        }
      }
      if (this.checkAllGroup.length === this.productList.length) {
        this.isCheckedAll = true
      } else {
        this.isCheckedAll = false
      }
      this_.$store.commit('SET_REQUEST', this_.hasBeChosed)
    },
    //获取搜索条件
    getSearchInfo () {
      let params = {
        release_channel: 2
      }
      getSearchConditionsInit(params).then(res => {
        if (res) {
          // 复制一个一级分类的名称
          this.productList = res.classiFiy//产品分类
          this.generalList = res.industry //适用行业
          this.payList = res.alternationMode //交付方式
          this.$nextTick(() => {
            if (this.$route.query.classifyId) {
              let list = this.productList.find(
                element => element.classify_id == this.$route.query.classifyId
              )
              this.checkedOne(1, list)
              list.checked = true
              this.handleGioTrack(1, list.checked, list.classify_name)
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.serviceProduct {
  .request-bar {
    padding: 15px;
    font-size: 14px;
    background-color: #fff;
    .request-item {
      display: flex;
      > div:nth-child(1) {
        width: 78px;
        color: #999;
      }
      > div:nth-child(2) {
        flex: 1;
        padding-bottom: 14px;
        .check-item-all {
          float: left;
          margin-right: 24px;
        }
        .check-item-one {
          float: left;
          margin-right: 24px;
          margin-bottom: 14px;
          .secondary-menu-box {
            position: relative;
            display: inline-block;
            width: 8px;
            height: 5px;
            .secondary-menu-img {
              width: 100%;
              height: 100%;
            }
            .secondary-menu-list {
              opacity: 0;
              z-index: -1;
              position: absolute;
              top: 21px;
              left: -54px;
              background: #fff;
              box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
              text-align: center;
              font-size: 12px;
              .secondary-menu-item {
                cursor: pointer;
                padding: 7px 12px;
                white-space: nowrap;
                &:hover {
                  background-color: #eaf5ff;
                }
              }
            }
          }
          &:hover {
            .secondary-menu-list {
              opacity: 1;
              z-index: 1;
            }
          }
        }
      }
      .hide-item {
        display: none;
      }
      .label-style {
        margin-right: 6px;
      }
    }
    .has-chose {
      margin-bottom: 19px;
      padding-bottom: 0;
      border-bottom: 1px dashed #e8e8e8;
      > div:nth-child(1) {
        color: #333;
        position: relative;
        padding-top: 5px;
        height: 55px;
        &:after {
          content: '>';
          display: inline-block;
          position: absolute;
          top: 4px;
          right: 7px;
        }
      }
      > div:nth-child(2) {
        display: flex;
        flex-wrap: wrap;
        > span {
          padding: 4px 8px 4px 14px;
          border: 1px solid rgba(48, 96, 255, 0.35);
          color: #3060ff;
          margin-right: 10px;
          margin-bottom: 5px;
        }
      }
      .iconfont {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/product/requestBar.vue